import React from "react";
import { Link } from "react-router-dom"; // Import Link for navigation

export default function NewArrivals({ product }) {
  return (
    <>
      {/* Inline CSS for animations */}
      <style>
        {`
          @keyframes fadeInUp {
            0% { opacity: 0; transform: translateY(20px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          @keyframes sparkle {
            0% { opacity: 0; transform: translateX(-100%); }
            50% { opacity: 1; }
            100% { opacity: 0; transform: translateX(100%); }
          }
          .animate-fadeInUp {
            animation: fadeInUp 1s ease-out forwards;
          }
          .animate-sparkle {
            position: absolute;
            inset: 0;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);
            animation: sparkle 2s infinite;
          }
          .hover-glow {
            transition: all 0.3s ease;
          }
          .hover-glow:hover {
            box-shadow: 0 0 20px rgba(212, 175, 55, 0.5);
          }
        `}
      </style>

      <div className="relative w-full max-w-xs mx-auto animate-fadeInUp">
        {/* Card Container */}
        <div className="relative bg-white rounded-sm overflow-hidden border border-gray-100 hover-glow transition-all duration-300 group">
          {/* Image as Background */}
          <div className="relative w-full h-80">
            <img
              src={product.images?.[0] || "/api/placeholder/400/320"} // Use the first image or fallback placeholder
              alt={product.name || "Product Image"}
              className="w-full h-full object-cover"
            />
            {/* Gradient Overlay for Readability */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>

            {/* New Arrival Badge with Sparkle Animation */}
            <div className="absolute top-4 left-4 bg-[#D4AF37] text-black text-xs font-bold px-3 py-1 rounded-full z-10">
              <span className="relative">
                New Arrival
                <span className="animate-sparkle"></span>
              </span>
            </div>

            {/* Content Overlay */}
            <div className="absolute bottom-0 left-0 right-0 p-4 text-center z-10">
              {/* Product Name */}
              <h3
                className="text-base font-semibold text-white mb-1 truncate"
              >
                {product.name || "Product Name"}
              </h3>

              {/* Price Section */}
              <div className="flex items-center justify-center gap-2 mb-1">
                <span className="text-lg font-bold text-white">
                  ₹{product.prices?.["50ml"] || "N/A"} {/* Added optional chaining */}
                </span>
              </div>

              {/* Fragrance Note */}
              <div className="mb-2">
                <span className="text-[#D4AF37] text-xs font-medium">
                  {product.fragranceNotes?.join(", ") || "Fragrance notes not available"} {/* Added optional chaining and fallback */}
                </span>
              </div>

              {/* Button with Link */}
              <Link to={`/product/${product.id}`} className="block w-full">
                <button className="w-full bg-[#D4AF37] text-black py-2 px-4 rounded-sm text-xs font-medium hover:bg-[#C19B2E] transition-all duration-200 transform hover:scale-105">
                  More Info
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}